"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i_configuration_1 = require("./i-configuration");
// Requests AND stores flag configurations
class ConfigurationRequestor {
    constructor(httpClient, flagConfigurationStore, banditVariationConfigurationStore, banditModelConfigurationStore) {
        this.httpClient = httpClient;
        this.flagConfigurationStore = flagConfigurationStore;
        this.banditVariationConfigurationStore = banditVariationConfigurationStore;
        this.banditModelConfigurationStore = banditModelConfigurationStore;
        this.banditModelVersions = [];
        this.configuration = new i_configuration_1.StoreBackedConfiguration(this.flagConfigurationStore, this.banditVariationConfigurationStore, this.banditModelConfigurationStore);
    }
    isFlagConfigExpired() {
        return this.flagConfigurationStore.isExpired();
    }
    getConfiguration() {
        return this.configuration;
    }
    async fetchAndStoreConfigurations() {
        const configResponse = await this.httpClient.getUniversalFlagConfiguration();
        if (!configResponse?.flags) {
            return;
        }
        const flagResponsePacket = {
            entries: configResponse.flags,
            environment: configResponse.environment,
            createdAt: configResponse.createdAt,
            format: configResponse.format,
        };
        let banditVariationPacket;
        let banditModelPacket;
        const flagsHaveBandits = Object.keys(configResponse.banditReferences ?? {}).length > 0;
        const banditStoresProvided = Boolean(this.banditVariationConfigurationStore && this.banditModelConfigurationStore);
        if (flagsHaveBandits && banditStoresProvided) {
            // Map bandit flag associations by flag key for quick lookup (instead of bandit key as provided by the UFC)
            const banditVariations = this.indexBanditVariationsByFlagKey(configResponse.banditReferences);
            banditVariationPacket = {
                entries: banditVariations,
                environment: configResponse.environment,
                createdAt: configResponse.createdAt,
                format: configResponse.format,
            };
            if (this.requiresBanditModelConfigurationStoreUpdate(this.banditModelVersions, configResponse.banditReferences)) {
                const banditResponse = await this.httpClient.getBanditParameters();
                if (banditResponse?.bandits) {
                    banditModelPacket = {
                        entries: banditResponse.bandits,
                        environment: configResponse.environment,
                        createdAt: configResponse.createdAt,
                        format: configResponse.format,
                    };
                    this.banditModelVersions = this.getLoadedBanditModelVersions(banditResponse.bandits);
                }
            }
        }
        if (await this.configuration.hydrateConfigurationStores(flagResponsePacket, banditVariationPacket, banditModelPacket)) {
            // TODO: Notify that config updated.
        }
    }
    getLoadedBanditModelVersions(entries) {
        return Object.values(entries).map((banditParam) => banditParam.modelVersion);
    }
    requiresBanditModelConfigurationStoreUpdate(currentBanditModelVersions, banditReferences) {
        const referencedModelVersions = Object.values(banditReferences).map((banditReference) => banditReference.modelVersion);
        return !referencedModelVersions.every((modelVersion) => currentBanditModelVersions.includes(modelVersion));
    }
    indexBanditVariationsByFlagKey(banditVariationsByBanditKey) {
        const banditVariationsByFlagKey = {};
        Object.values(banditVariationsByBanditKey).forEach((banditReference) => {
            banditReference.flagVariations.forEach((banditVariation) => {
                let banditVariations = banditVariationsByFlagKey[banditVariation.flagKey];
                if (!banditVariations) {
                    banditVariations = [];
                    banditVariationsByFlagKey[banditVariation.flagKey] = banditVariations;
                }
                banditVariations.push(banditVariation);
            });
        });
        return banditVariationsByFlagKey;
    }
}
exports.default = ConfigurationRequestor;
//# sourceMappingURL=configuration-requestor.js.map